(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["np-page-transition"] && !Shopify.designMode) return;
  try {
    (() => {
    const loader = document.querySelector('[data-np-page-transition]');
    if (!(loader instanceof HTMLElement) || window.Shopify?.designMode) return;

    const storageKey = 'np-page-transition-pending';
    let fallbackTimer;

    const show = () => {
      window.clearTimeout(fallbackTimer);
      loader.classList.remove('is-complete');
      loader.classList.add('is-active');
    };

    const hide = (immediate = false) => {
      window.clearTimeout(fallbackTimer);
      if (immediate) {
        loader.classList.remove('is-active', 'is-complete');
        return;
      }

      loader.classList.add('is-complete');
      window.setTimeout(() => loader.classList.remove('is-active', 'is-complete'), 180);
    };

    const isInternalPageLink = (link, event) => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
      if (link.hasAttribute('download') || link.target === '_blank' || link.hasAttribute('data-no-page-transition')) return false;

      const href = link.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')) return false;

      const destination = new URL(link.href, window.location.href);
      if (destination.origin !== window.location.origin) return false;

      const currentWithoutHash = `${window.location.pathname}${window.location.search}`;
      const destinationWithoutHash = `${destination.pathname}${destination.search}`;
      if (currentWithoutHash === destinationWithoutHash) return false;

      return true;
    };

    if (sessionStorage.getItem(storageKey) === '1') {
      sessionStorage.removeItem(storageKey);
      show();

      const finishArrival = () => window.setTimeout(hide, 30);
      if (document.readyState !== 'loading') {
        finishArrival();
      } else {
        window.addEventListener('DOMContentLoaded', finishArrival, { once: true });
        fallbackTimer = window.setTimeout(hide, 420);
      }
    }

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const link = target.closest('a[href]');
      if (!(link instanceof HTMLAnchorElement) || !isInternalPageLink(link, event)) return;

      sessionStorage.setItem(storageKey, '1');
      show();
      fallbackTimer = window.setTimeout(() => {
        sessionStorage.removeItem(storageKey);
        hide();
      }, 4000);
    }, true);

    window.addEventListener('pageswap', () => {
      sessionStorage.setItem(storageKey, '1');
      show();
    });

    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        sessionStorage.removeItem(storageKey);
        hide(true);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
